import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Card, Input, Icon, Label } from 'semantic-ui-react';
import validator from 'validator';

class CollaborationEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.email || '',
      isEditing: false,
      isInvalid: false,
    };
  }

  onChange = (e, { value }) => this.setState({
    value,
    isInvalid: !validator.isEmail(value),
  });

  toggleInputState = () => this.setState({
    isEditing: !this.state.isEditing,
  })

  refreshPage = () => {
    window.location.reload(true);
  }

  persistEmail = async email => {
    if (validator.isEmail(email)) {
      const { saveNewEmail } = this.props;
      await saveNewEmail(email);
      this.setState({
        value: email,
        isEditing: false,
      });
      this.refreshPage();
    } else {
      this.setState({
        value: email,
        isInvalid: true,
      });
    }
  }

  render() {
    const {
      value,
      isEditing,
      isInvalid,
    } = this.state;

    const inputActionProps = {
      icon: isEditing ? 'save' : 'pencil',
      onClick: isEditing ? () => this.persistEmail(value) : this.toggleInputState,
      disabled: isEditing && _.isEmpty(value),
      color: isEditing ? 'pink' : 'green',
    };

    return (
      <Card fluid>
        <Card.Content>
          <h3>Email</h3>
        </Card.Content>
        <Card.Content>
          <Input
            fluid
            onChange={this.onChange}
            disabled={!isEditing}
            defaultValue={value}
            value={value}
            action={inputActionProps}
            error={isInvalid}
          />
        </Card.Content>
        {
          (isInvalid || !value) &&
          <Card.Content meta textAlign="center">
            <Label color="red" basic><Icon name="ban" color="red" />Invalid email</Label>
          </Card.Content>
        }
      </Card>
    );
  }
}

CollaborationEmail.propTypes = {
  email: PropTypes.string.isRequired,
  saveNewEmail: PropTypes.func.isRequired,
};

export default CollaborationEmail;



/** WEBPACK FOOTER **
 ** ./src/components/collaboration-email/index.js
 **/